module.exports = __webpack_public_path__ + "static/media/bgm.7bffb043.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/asset/bgm.mp3
// module id = 1789
// module chunks = 0